/********************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2016, 2024
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} **/

import React from 'react';
import { withTranslation } from 'react-i18next';
import Operation from './Operation';
import { Accordion, AccordionItem } from '@carbon/react';
import { useApi } from 'contexts/ApiHandler';
import { useConfig } from 'contexts/config';

const Callback = ({ event, callbacks, operation, apps, ...others }) => {
  const { api } = useApi();
  const { options } = useConfig();

  operation = JSON.parse(JSON.stringify(operation));
  operation.openapi = api.openapi;

  return (
    <div className="callbacks-tab-content" {...others}>
      <div className="eventName">{event}</div>
      <Accordion>
        {Object.keys(callbacks).map((path) => {
          let [method, callback] = Object.entries(callbacks[path])[0];
          return (
            <AccordionItem className="callback-accordion" key={callback} title={method.toUpperCase() + ' ' + path} open={true}>
              <Operation api={operation} operation={callback} operationPath={path} operationMethod={method} options={options} apps={apps} isCallback={true} />
            </AccordionItem>
          );
        })}
      </Accordion>
    </div>
  );
};

export default withTranslation()(Callback);
